import FloatingPage from "../General/FloatingPage"
import { useContext, useState } from "react"
import { Row, Col } from "react-bootstrap";
import { BeatLoader } from "react-spinners";
import styles from "./Curriculum.module.scss";
import { AuthContext } from "AuthContext";
import { BookContext } from "./BookContext";
import TextbookItem from "./TextbookItem";
import { useNavigate } from "react-router"
import { Modal } from "react-bootstrap"
import { createSearchParams, useSearchParams } from "react-router-dom";
import { CurriculumBook } from "shared/types/curriculumTypes";

export default function TextbookPage() {
    const authInfo = useContext(AuthContext)
    const bookInfo = useContext(BookContext)
    const textbooks = bookInfo.textbooks
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const lessonPlanId = searchParams.get("lessonPlanId")
    const [disabledProductModal, setDisabledProductModal] = useState<boolean>(false)

    const onClick = (textbook: CurriculumBook) => {
        if (!textbook.available) {
            setDisabledProductModal(true)
        } else {
            navigate({
                pathname: `/books/units/${textbook.id}`,
                search: lessonPlanId ? createSearchParams({ lessonPlanId }).toString() : undefined
            })
        }
    }

    return (
        <FloatingPage className={styles.background}>
            {authInfo.hasCurriculumAccess && <>
                <h1>Textbooks</h1>
                <Row className="my-5 justify-content-center" style={{ gap: "1rem 0rem" }}>
                    {textbooks.length === 0 ? (
                        <Col md={4}>
                            <h3>Loading textbooks...</h3>
                            <BeatLoader size={10} speedMultiplier={0.8} />
                        </Col>
                    ) : <>
                        {textbooks.map((textbook) => (
                            <TextbookItem key={textbook.id} textbook={textbook} onClick={() =>
                                onClick(textbook)
                            } />
                        ))}
                    </>
                    }
                </Row>
            </>}
            <Modal size="lg" show={disabledProductModal} onHide={() => setDisabledProductModal(false)}>
                <Modal.Header closeButton />
                <Modal.Body>
                    You do not currently own a license for this product; to purchase it, please contact STEM Sims at sales@stemsims.com.
                </Modal.Body>
            </Modal>
        </FloatingPage>
    );
}
